import React from "react";
import TeacherGlassCard from "./TeacherGlassCard";
import { ICONS } from "./constants";

export default function TeacherStatsSection({
  teacherCount,
  executiveCount,
  minuteCount,
  monthlyMinuteCount,
}) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      <TeacherGlassCard className="p-5 flex flex-col items-center justify-center text-center h-full relative overflow-hidden gap-2 border border-white/60 bg-white rounded-[2rem] shadow-sm hover:shadow-md transition-all" noHover>
        <div className="absolute -right-6 -top-6 w-28 h-28 rounded-full opacity-10 blur-2xl bg-blue-400"></div>
        <div className="relative z-10 flex flex-col items-center">
          <div className="p-3 rounded-2xl bg-gray-50 shadow-sm border border-gray-100 mb-2">
            <img src={ICONS.teacher} width={36} alt="icon" className="drop-shadow-sm" />
          </div>
          <h3 className="text-gray-500 text-sm font-bold tracking-wide mb-0.5">총 교사</h3>
          <div className="flex items-end gap-1.5 mb-1">
            <span className="text-4xl font-black text-[#2C3E30] font-do-hyeon leading-none">{teacherCount}</span>
            <span className="text-sm font-bold text-gray-400 mb-1">명</span>
          </div>
          <span className="text-xs text-gray-400 bg-gray-50 px-2.5 py-0.5 rounded-full border border-gray-100">등록 교사</span>
        </div>
      </TeacherGlassCard>

      <TeacherGlassCard className="p-5 flex flex-col items-center justify-center text-center h-full relative overflow-hidden gap-2 border border-white/60 bg-white rounded-[2rem] shadow-sm hover:shadow-md transition-all" noHover>
        <div className="absolute -right-6 -top-6 w-28 h-28 rounded-full opacity-10 blur-2xl bg-orange-400"></div>
        <div className="relative z-10 flex flex-col items-center">
          <div className="p-3 rounded-2xl bg-gray-50 shadow-sm border border-gray-100 mb-2">
            <img src={ICONS.folder} width={36} alt="icon" className="drop-shadow-sm" />
          </div>
          <h3 className="text-gray-500 text-sm font-bold tracking-wide mb-0.5">부장/총무</h3>
          <div className="flex items-end gap-1.5 mb-1">
            <span className="text-4xl font-black text-[#2C3E30] font-do-hyeon leading-none">{executiveCount}</span>
            <span className="text-sm font-bold text-gray-400 mb-1">명</span>
          </div>
          <span className="text-xs text-gray-400 bg-gray-50 px-2.5 py-0.5 rounded-full border border-gray-100">임원진</span>
        </div>
      </TeacherGlassCard>

      <TeacherGlassCard className="p-5 flex flex-col items-center justify-center text-center h-full relative overflow-hidden gap-2 border border-white/60 bg-white rounded-[2rem] shadow-sm hover:shadow-md transition-all" noHover>
        <div className="absolute -right-6 -top-6 w-28 h-28 rounded-full opacity-10 blur-2xl bg-green-400"></div>
        <div className="relative z-10 flex flex-col items-center">
          <div className="p-3 rounded-2xl bg-gray-50 shadow-sm border border-gray-100 mb-2">
            <img src={ICONS.notebook} width={36} alt="icon" className="drop-shadow-sm" />
          </div>
          <h3 className="text-gray-500 text-sm font-bold tracking-wide mb-0.5">총 회의록</h3>
          <div className="flex items-end gap-1.5 mb-1">
            <span className="text-4xl font-black text-[#2C3E30] font-do-hyeon leading-none">{minuteCount}</span>
            <span className="text-sm font-bold text-gray-400 mb-1">건</span>
          </div>
          <span className="text-xs text-gray-400 bg-gray-50 px-2.5 py-0.5 rounded-full border border-gray-100">누적 기록</span>
        </div>
      </TeacherGlassCard>

      <TeacherGlassCard className="p-5 flex flex-col items-center justify-center text-center h-full relative overflow-hidden gap-2 border border-white/60 bg-white rounded-[2rem] shadow-sm hover:shadow-md transition-all" noHover>
        <div className="absolute -right-6 -top-6 w-28 h-28 rounded-full opacity-10 blur-2xl bg-purple-400"></div>
        <div className="relative z-10 flex flex-col items-center">
          <div className="p-3 rounded-2xl bg-gray-50 shadow-sm border border-gray-100 mb-2">
            <img src={ICONS.calendar} width={36} alt="icon" className="drop-shadow-sm" />
          </div>
          <h3 className="text-gray-500 text-sm font-bold tracking-wide mb-0.5">이번 달 회의</h3>
          <div className="flex items-end gap-1.5 mb-1">
            <span className="text-4xl font-black text-[#2C3E30] font-do-hyeon leading-none">{monthlyMinuteCount}</span>
            <span className="text-sm font-bold text-gray-400 mb-1">건</span>
          </div>
          <span className="text-xs text-gray-400 bg-gray-50 px-2.5 py-0.5 rounded-full border border-gray-100">월간 현황</span>
        </div>
      </TeacherGlassCard>
    </div>
  );
}
